// extracted by mini-css-extract-plugin
export default {"lootbox-section__info":"LootboxSection_lootbox-section__info__SWhbT"};